window._ = require('lodash');


// WEBPACK FOOTER //
// ./src/plugins/lodash.js